<div class="modal-header">
  <h4 class="modal-title header-5">
    {{ configs?.title }}
  </h4>
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
</div>

<div class="modal-body">
  <span class="header-8"> {{ configs?.subTitle }} </span>
  <div class="step">
    <ol class="mt-3">
        <li *ngFor="let step of configs?.steps" [innerHTML]="step" class="header-12-1"></li>
      </ol>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2 open-btn"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button *ngIf="configs?.buttonText"
      class="btn-accello-primary-light open-btn"
      (click)="onClick()"
    >
      {{ configs?.buttonText }}
    </button>
  </div>
</div>
